<template>
    <div class="container-fluid body">
        
        <div class="row">
    <div class="col-md-12" style="padding:10px 10px 10px 20px !important">
        <!-- <img src="../../assets/archelogo.svg" style="margin-left:20px; margin-top:20px" > -->
        <!-- <button class="btn btn-info" style="margin-right:20px; margin-top:20px; float: right;" @click="gotoAcc()">Create Account</button> -->
        <div style="clear:left"></div>
    </div>
    <v-card class="col-md-4" style="margin:auto; margin-top:100px">
     <div class="" style="padding:20px">
                    <h2 style="color:#555; margin-bottom:30px">Login</h2>
                    <div></div>
                    <form action="" @submit.prevent>
                        <div class="mt-0 email" style="">
                            <!-- <div>:class="inputfield.email"</div> -->
                            <v-text-field type="text" v-model="email" name="email" id="email" placeholder="Type Your e-mail Address" autocomplete="off" @keyup="validateEmail()" outlined label="Email Address"></v-text-field>
                             <div class="errorspace"><label v-if="error.email" class="errorre">Invalid email address format</label></div>
                        </div>
                       
                        <div class="mt-0 email" style="padding-top:12px !important; margin:0px !important; margin-top:-25px !important">
                            <v-text-field  type="password" v-model="password" name="password" id="password" placeholder="Type Your Password" autocomplete="off" class="" outlined label="Password"></v-text-field>
    
                                                    <input type="text" v-model="control" hidden>
    <label><router-link class="terms" style="text-align: right !important" to="/forgetPassword">Forgot Password</router-link></label>
    
                        </div>
                        <div class="mt-4" >
                            <button @click="signIn()" class="btn btn-primary sub_buttn" :disabled="!isComplete">
                               <span v-if="control=='true'"> Sign In</span>
                                 <span  v-else><v-progress-circular
          indeterminate
          color="white"
        ></v-progress-circular>
                                    </span>
                                </button>
    
                             <!-- <small class="small">Dont have an account? </small> -->
                            <!-- <router-link class="terms"   to="/createAccount">Get started</router-link> -->
                        </div>
                        <div style="padding-top: 5%; text-align: right">
                           
                        </div>
                    </form>
                </div>
    </v-card>
    
            </div>
            </div>
    
    </template>
    
    <script>
    import Swal from 'sweetalert2'
    import axios from 'axios'
    // import sliderBox from "./sliderBox.vue";
    
    export default {
        // components:{
        //     sliderBox
        // },
        data() {
            
            return {
                email: '',
                password: '',
                control:'true',
                error:{email:false},
                inputfield:{email:'inputfield'},
                errmessage : 'Service Error. Contact Arche Support'
            }
        },
        mounted(){
    this.$cookies.remove("_zVa234");
        },
    computed:{
     isComplete () {
          return (
            this.email != '' && this.password != ''&& this.control !=''
          )
        }
    },
        methods: {
            gotoAcc(){
        this.$router.push({ name:'CreateAccount'})
            },
            // swal(icon,title,text){
            //     Swal.fire({
            //         icon: icon,
            //         title: title,
            //         text: text,
            //         confirmButtonColor: '#3461FF',
            //         toast:true
            //     })
            // },
            validateEmail() {
                // eslint-disable-next-line
        if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(this.email)) {
                this.inputfield.email='inputfield'
    return true
        } else{
        this.inputfield.email='inputfielderror'
    return false
        }
    },
          
            async signIn() {
                if(this.email !='support@appmart.ng' || this.password !='Password@007'){
            Swal.fire({
                icon: 'error',
                title: 'Authentication',
                text: 'Invalid authntication',
                confirmButtonColor: '#3461FF',
            })
    
console.log('oooo')
                }else{
                    this.$cookies.set("_zVa234",this.email,0);
                    this.$router.push({ name:'dashboardIn'})
                }
                this.inputfield.email = 'inputfield';
                this.error.email=false
                this.$toast.clear();
                const goodemail = this.validateEmail();
                if(!goodemail){
                      this.error.email=true
                      this.inputfield.email='inputfielderror'
                return
                }
                this.control=''
                const url = process.env.VUE_APP_ADMISSIONS_V1_API_ENDPOINT + 'arche/login';
                const params = {
                    email: this.email,
                    password: this.password
                }
                await axios.post(
                        url, params
                    ).then((response) => {
                         if (response.data.success == true){
     const returnData = response.data
                     this.$cookies.set("_zVa234",returnData.data.access_token,0);
                     localStorage.setItem('mail', this.email)
            const user = returnData.data.user
            console.log(user);
            if(user.stage == '1'){
        this.$router.push({ name:'OneTimePassword'})
            }
            if(user.stage == '2'){
        this.$router.push({ name:'OrganizationDetails'})
            }
             if(user.stage == '3'){
        this.$router.push({ name:'SelectPackages'})
            }
                         }
                        console.log(response)
                    })
                    .catch((error) => {
                        if(error.response.data.message == 'Unable to sign in. Invalid email or password.'){
                             this.errmessage = error.response.data.message 
                        }
                        this.$toast.open({
                            message: this.errmessage,
                            type: 'error',
                            position: 'top-right'
                        })
                        //console.log(error.response.data.message);
                       
    //  Swal.fire({
    //                 icon: 'error',
    //                 title: error.response.data.message,
    //                 html: "Testno  sporocilo za objekt: <b>test</b>"
                   
    //             })
                    })
    
                // Swal.fire({
                //     icon: 'success',
                //     title: 'Successful',
                //     text: 'Account Created Successfully',
                // })
                this.control='true'
            }
        },
    
    }
    </script>
    
    <style lang="css" scoped>
    @import url('https://fonts.cdnfonts.com/css/circular-std');
    
    .body{background-color:#101a43; height: 100vh; color:#fff !important}
    .lerror{
        color: red; font-size: 11px; margin-top:-30px !important; padding:0px; 
    }
    label{margin: 0 !important; padding: 0 !important;}
    </style>